module.exports = __webpack_public_path__ + "static/img/PC-6.c896e6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcyixuekao/PC-6.png
// module id = yI91
// module chunks = 0